import React from 'react'
import '../../Styles/exploreproperty.css'
import { useNavigate } from 'react-router-dom';

const ExploreProperty = ({ categoryData }) => {
  const navigate = useNavigate()

  return (
    <>
      <section className='explore-property'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 property-heading-col'>
              <h3>Explore Our Properties</h3>

              <a onClick={() => navigate("/categories")} style={{ cursor: "pointer" }}>
                <h5>
                  See All Properties
                  <span><img src="/images/btn-arrow.png" alt="Arrow Icon" /></span>
                </h5>
              </a>
            </div>
          </div>
          <div className='row explore-row'>

            {categoryData && categoryData.map((property, index) => (
              <div className="col-md-4" key={index}>
                <div className="explore-property-box" style={{ backgroundImage: `url(${property.image})`, cursor: "pointer" }} onClick={() => navigate(`/property-listing?property_type=${property.slug}-${property.id}`)}>
                  <h5>{property.category_name}</h5>
                  {/* <p>{property.count}</p> */}
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  )
}

export default ExploreProperty
